<div class="footer-container">
    <div class="footer-content">
        <div class="copyright-text">Copyright™ 2024 Loyalty Juggernaunt Inc.</div>
    </div>
</div>
